export default __webpack_public_path__ + "static/media/city.c192440b.png";